






















































































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import SpaceComponent from "@/app/components/modals/changeSpace/space.component.vue";
import Loader from "@/resources/mixins/loader/loader";
@Component({ name: "change-space-component", components: { SpaceComponent } })
export default class ChangeSpaceComponent extends mixins(
  UserValidator,
  Loader
) {
  selectId = 0;
  city = false;
  superSpaceId = 0;
  returnToTheCity = true;
  loaderReload = false;
  time = 10000;
  timer = null;
  isTeams = localStorage.getItem("isTeams");
  async created(): Promise<void> {
    await this.retryReload();
    this.checkMaxConnections();
  }
  destroyed() {
    if (this.timer) clearInterval(this.timer);
  }
  get active(): boolean {
    return this.$store.getters["SystemStore/getOpenChangeSpaceModal"];
  }
  set active(e: boolean) {
    this.$store.dispatch("SystemStore/setOpenChangeSpaceModalAction", e);
  }
  get spaceAvailable() {
    return this.$store.getters["SpaceStore/getSpacesAvailable"];
  }
  get spaceSuperSpace() {
    return this.$store.getters["SpaceStore/getSuperSpace"];
  }
  get isOnline() {
    return this.$store.getters["UserStore/getIsOnline"];
  }
  async mounted(): Promise<void> {
    this.city = localStorage.getItem("city") == "ON" ? true : false;
    await this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    await this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    const space = await this.$store.getters["SpaceStore/getSpace"];
    if (space) {
      this.superSpaceId = space.superSpace.id;
      this.returnToTheCity = space.superSpace.returnToTheCity;
    } else {
      const superSpaceId =
        this.$store.getters["SystemStore/getSelecSuperSpaceId"];
      if (superSpaceId) this.superSpaceId = superSpaceId;
    }

    this.stopLoader(this.$store);
    //this.getAllSpaces();
  }
  async retryReload() {
    this.timer = setTimeout(async () => {
      await this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
      await this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
      this.getAllSpacesRetry();
      await this.retryReload();
      this.checkMaxConnections();
    }, this.time);
  }
  /*async reload() {
    await this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    await this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    this.getAllSpaces();
  }*/
  getAllSpaces(): void {
    this.loaderReload = true;
    this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: this.superSpaceId,
      callback: (response) => {
        setTimeout(() => {
          this.loaderReload = false;
        }, 2000);
        this.stopLoader(this.$store);
      },
      callbackError: () => {
        this.stopLoader(this.$store);
        return [];
      },
    });
  }
  getAllSpacesRetry(): void {
    this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: this.superSpaceId,
      callback: (response) => {
        this.stopLoader(this.$store);
      },
      callbackError: () => {
        this.stopLoader(this.$store);
        return [];
      },
    });
  }
  logOut(): void {
    this.$store.dispatch("SystemStore/setShowExitModalAction", true);
    this.active = false;
  }
  logout(): void {
    this.$store.dispatch("AuthStore/logOutAction");
  }
  goToCity(): void {
    localStorage.setItem("city", "ON");
    window.location.reload();
  }
  get disabledLoader(): boolean {
    const lastPage = this.$store.getters["SpaceStore/getLastPageSpaces"];
    const page = this.$store.getters["SpaceStore/getSpacesAvailablePage"];
    return page > lastPage;
  }
  getMoreSpaces(): void {
    //const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: this.superSpaceId,
      callback: () => {
        document.getElementById("space-list").scrollTop =
          document.getElementById("space-list").scrollHeight - 800;
      },
      callbackError: () => {
        // do nothing
      },
    });
  }
  checkMaxConnections(): boolean {
    if (this.spaceSuperSpace.usersConnected >= this.spaceSuperSpace.usersConnectedLimit) {
      return true;
    }
    return false;
  }
}
